/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { SendUploadEmailCommandSendUploadEmailDTO } from '../models/SendUploadEmailCommandSendUploadEmailDTO';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UploadApiService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param personGuid
     * @param fileName
     * @param filekey
     * @param chunkNumber
     * @param hashHexOfCombinedFile
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public postApiV10Upload(
        personGuid?: string,
        fileName?: string,
        filekey?: string,
        chunkNumber?: number,
        hashHexOfCombinedFile?: string,
        formData?: {
            fileChunk?: Array<Blob>;
        },
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Upload',
            query: {
                'personGuid': personGuid,
                'fileName': fileName,
                'filekey': filekey,
                'chunkNumber': chunkNumber,
                'hashHexOfCombinedFile': hashHexOfCombinedFile,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param personGuid
     * @param fileName
     * @param filekey
     * @param chunkNumber
     * @param chunkStartByte
     * @param chunkEndByteInclusive
     * @param totalFileSize
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public postApiV10UploadUploadChunkToGraph(
        personGuid?: string,
        fileName?: string,
        filekey?: string,
        chunkNumber?: number,
        chunkStartByte?: number,
        chunkEndByteInclusive?: number,
        totalFileSize?: number,
        formData?: {
            fileChunk?: Array<Blob>;
        },
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Upload/UploadChunkToGraph',
            query: {
                'personGuid': personGuid,
                'fileName': fileName,
                'filekey': filekey,
                'chunkNumber': chunkNumber,
                'chunkStartByte': chunkStartByte,
                'chunkEndByteInclusive': chunkEndByteInclusive,
                'totalFileSize': totalFileSize,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param personGuid
     * @param fileKey
     * @param fileName
     * @returns any OK
     * @throws ApiError
     */
    public postApiV10UploadCombineChunks(
        personGuid?: string,
        fileKey?: string,
        fileName?: string,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Upload/CombineChunks',
            query: {
                'personGuid': personGuid,
                'fileKey': fileKey,
                'fileName': fileName,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public postApiV10UploadSendUploadEmail(
        requestBody?: SendUploadEmailCommandSendUploadEmailDTO,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v1.0/Upload/SendUploadEmail',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
